import IconComponent from "icons/IconComponent";

import UtensilsIcon from "./utensils.svg";

export default (UtensilsIcon as any) as IconComponent;
